/**
 * @deprecated Prefer `import { apiGet, apiPost, apiPatch, apiDelete, apiDownload } from '@/lib/api-client'`.
 *
 * This file is a compatibility shim that keeps the legacy API surface
 * (`fetchJSON`, `postJSON`, `patchJSON`, `deleteJSON`, `downloadFile`, `apiFetchJSON`,
 * `apiPostJSON`, `apiPatchJSON`, `apiDeleteJSON`) working while pages are gradually
 * migrated to the typed client.
 *
 * Under the hood, everything delegates to `src/lib/api-client.ts`, which means:
 * - 401 now dispatches a global event instead of `window.location.href = '/login'`
 * - Errors are `ApiError` with normalized shape
 * - Token retrieval is centralized via STORAGE_KEYS.JWT_TOKEN
 */

import { apiDelete, apiDownload, apiGet, apiPatch, apiPost } from '@/lib/api-client';

const PROJECTS_PREFIX = '/projects';

// ── Project-scoped helpers (legacy: paths like `/<id>/register`) ──
export const fetchJSON = (path) => apiGet(`${PROJECTS_PREFIX}${path}`);
export const postJSON = (path, body) => apiPost(`${PROJECTS_PREFIX}${path}`, body);
export const patchJSON = (path, body) => apiPatch(`${PROJECTS_PREFIX}${path}`, body);
export const deleteJSON = (path) => apiDelete(`${PROJECTS_PREFIX}${path}`);

// ── Generic (full absolute paths like `/api/v1/auth/users`) ──
// The typed client handles `/api/v1` prefixing — strip it here if present.
function stripPrefix(url) {
  return url.startsWith('/api/v1') ? url.slice('/api/v1'.length) : url;
}

export const apiFetchJSON = (url) => apiGet(stripPrefix(url));
export const apiPostJSON = (url, body) => apiPost(stripPrefix(url), body);
export const apiPatchJSON = (url, body) => apiPatch(stripPrefix(url), body);
export const apiDeleteJSON = (url) => apiDelete(stripPrefix(url));

// ── Download ──
export const downloadFile = (path, filename) =>
  apiDownload(`${PROJECTS_PREFIX}${path}`, filename);
